import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { handleSelectedVariant, setProductVariants } from '../../../../../Features/dropTrackActionSlice';

const sizes = ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'];

function ProductColorsAndSizes({ product }) {
    const dispatch = useDispatch();

    const [selectedSizes, setSelectedSizes] = useState(sizes);

    const selectedProductVariants = useSelector((state) => state.dropTrackAction.selectedProductVariants);

    const handleVariantClick = (variant) => {
        dispatch(handleSelectedVariant(variant));
    }

    const handleSizeClick = (size) => {
        if(selectedSizes.includes(size)) {
            const filteredSizes = selectedSizes.filter(item => item !== size);
            setSelectedSizes(filteredSizes);
        }
        else {
            setSelectedSizes([ ...selectedSizes, size ]);
        }
    }

    useEffect(() => {
        dispatch(setProductVariants(product.varients));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="flex flex-col gap-3 font-urbanist-regular">
            <h1 className='font-semibold text-[14px] leading-[22px] text-[#000000]'>{product.product.productName}</h1>
    
            {
                product.varients.length > 0 ? 
                <>
                    <div className="flex flex-col gap-2">
                        <h2 className='font-semibold text-[14px] leading-[22px] text-[#666666]'>Colors</h2>

                        <div className="flex flex-wrap gap-2">
                            {product.varients?.map(variant => {
                                return (
                                    <div onClick={() => handleVariantClick(variant)} key={variant.id} className={`cursor-pointer w-[174px] h-[174px] bg-[#F5F5F5] rounded-[15.45px] border-b-2 ${selectedProductVariants.includes(variant) ? 'border-primaryColor' : 'border-[#F5F5F5]'}`}>
                                        <img src={variant.VarientImgUrl[0]} alt="" className="object-cover h-[77%] w-full rounded-[15.45px]" />

                                        <h1 className='font-normal select-none text-[14px] leading-[22px] h-[23%] flex items-center justify-center'>{variant.VarientColor}</h1>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className="flex flex-col gap-2">
                        <h2 className='font-semibold text-[14px] leading-[22px] text-[#666666]'>Size</h2>

                        <div className="flex flex-wrap gap-2">
                            {sizes.map(size => {
                                return (
                                    <div onClick={() => handleSizeClick(size)} key={size} className={`cursor-pointer px-4 py-2 rounded-lg ${selectedSizes.includes(size) ? 'bg-primaryColor' : 'bg-buttonDisabledBg'} border border-[#EAEAEA]`}>
                                        <h1 className="font-semibold select-none text-[14px] leading-[26px] text-buttonText">{size}</h1>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </> : 
                <p className='italic text-[14px] leading-[22px] text-[#666666]'>No variants available for <span className='font-semibold'>{product.product.productName}</span></p>
            }
        </div>
    );
}

export default ProductColorsAndSizes;
